import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { getVisitorsDetails } from '../../../axios/Visitor/VisitorApi';
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
import { useAuth } from '../../../context/AuthContext';
import { format, parseISO } from 'date-fns';
import { CustomAdvancedMenuList, CustomTabPanel, CustomTabsV2 } from '../../../components/StyledComponents';
import { ClickAwayListener, Grow, MenuItem, Paper, Popper, Tab } from '@mui/material';
import DeleteVisitorUserDialog from './DeleteVisitorUserDialog';
import VisitorUserEventGridInfoTable from './VisitorUserEventGridInfoTable';
import { toast } from 'react-toastify';
import { useLoading } from '../../../context/LoadingContext';
import EditNew20pxSvg from "../../../assets/images/icons/EditNew20pxSvg";
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import RemoveUserIcon from "../../../assets/images/icons/RemoveUserIcon";
import EditVisitorUserDialog from './EditVisitorUserDialog';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';

const VisitorUserInfo = ({
    selectedRow,
    isListEmpty = false,
    setSelectedRow,
    refreshData,
    handleRefreshData,
    refresh
}) => {
    const { t } = useTranslation();
    const { genaralSettingDateFormat } = useAuth();
    const [tabValue, setTabValue] = useState(0);
    const [openDeleteVisitorUser, setOpenDeleteVisitorUser] = useState(false);
    const [openEditVisitorUser, setOpenEditVisitorUser] = useState(false);
    const [, setNewSelectedRow] = useState({});
    const [data, setData] = useState(null);
    const [show, hide] = useLoading();
    const [openStatus, setOpenStatus] = useState(false);
    const handleCloseStatus = () => setOpenStatus(false);
    const anchorRefStatus = useRef(null);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };


    const a11yProps = (index) => {
        return {
            id: `user-tab-${index}`,
            'aria-controls': `user-tabpanel-${index}`,
        };
    };

    const fetchData = async () => {
        if (!selectedRow?.id) return;

        const payload = {
            id: selectedRow?.id,
            langId: localStorage.getItem("i18nextLngId"),
        };
        try {
            show();
            const response = await getVisitorsDetails(payload);

            if (response?.data?.responseCode === 0) {
                setData(response?.data?.data?.[0] ?? null);
            } else {
                setData(null);
                toast.error(
                    response?.data?.message ||
                    t("common.something-went-wrong")
                );
            }
        } catch (error) {

            console.error(error);
            setData(null);

            toast.error(
                error?.response?.data?.message ||
                t("common.something-went-wrong")
            );

        } finally {
            hide();
        }
    };

    useEffect(() => {
        if (isListEmpty || !selectedRow?.id) {
            setData(null);
            return;
        }

        setData(null);
        fetchData();
    }, [selectedRow?.id, refresh, refreshData, isListEmpty]);

    const hasData = !isListEmpty && Boolean(
        selectedRow?.id &&
        data &&
        typeof data === "object" &&
        !Array.isArray(data) &&
        (data.id || data.fullName)
    );

    return (
        <>
            <div>
                <p className="text-xl font-semibold">
                    {data?.fullName || t("common.user-detail")}
                </p>
                <CustomTabsV2
                    variant="fullWidth"
                    indicatorColor='none'
                    value={tabValue}
                    onChange={handleChangeTab}
                >
                    <Tab
                        label={t('button.details')}
                        {...a11yProps(0)}
                        disableRipple
                    />

                    <Tab
                        label={t('common.events')}
                        {...a11yProps(1)}
                        disableRipple
                        disabled
                    />
                </CustomTabsV2>
                <CustomTabPanel value={tabValue} index={0}>
                    {!hasData ? (
                        <div className="flex items-center justify-center min-h-[55vh]">
                            <NoRowOverlay />
                        </div>
                    ) : (
                        <>
                    <div className='flex gap-2 justify-end'>
                        <div className="flex rounded-md border border-[#DBE8FF] overflow-hidden bg-[#F5F8FF] h-10">
                            <button
                                onClick={() => setOpenEditVisitorUser(true)}
                                className="flex items-center gap-2 px-4 py-2 text-[#0057FF] hover:bg-blue-100 h-[38px]"
                            >
                                <EditNew20pxSvg />
                                {t("button.edit")}
                            </button>

                            <div className="w-[1px] bg-[#DBE8FF]" />

                            <button
                                ref={anchorRefStatus}
                                onClick={() => setOpenStatus((prev) => !prev)}
                                className="px-3 py-2 hover:bg-blue-100 flex items-center text-[#0057FF]"
                            >
                                <ArrowDropDownIcon />
                            </button>
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <div className="p-1 rounded border border-[#E5E7EB]">
                            <img
                                src={
                                    data?.profileImageUrl
                                        ? `data:image/png;base64,${data.profileImageUrl}`
                                        : avatar_2
                                }
                                alt="avatar"
                                className="w-[128px] h-[128px] object-cover rounded"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-[160px_1fr] gap-y-4 gap-x-2 mt-4">

                        <p className="font-semibold text-[#6B7280]">
                            {t("common.fullname")}
                        </p>
                        <p>
                            {data?.fullName}
                        </p>

                        <p className="font-semibold text-[#6B7280]">
                            {t("common.personal-id")}
                        </p>
                        <p>
                            {data?.citizenIdentificationNumber}
                        </p>

                        <p className="font-semibold text-[#6B7280]">
                            {t("common.email")}
                        </p>
                        <p>
                            {data?.email}
                        </p>

                        <p className="font-semibold text-[#6B7280]">
                            {t("common.phone")}
                        </p>
                        <p>
                            {data?.mobile}
                        </p>

                        <p className="font-semibold text-[#6B7280]">
                            {t("common.joinedDate")}
                        </p>
                        <p>
                            {data?.createdAt
                                ? format(
                                    parseISO(data.createdAt),
                                    genaralSettingDateFormat
                                )
                                : ""}
                        </p>

                    </div>
                        </>
                    )}
                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={1}>
                    <VisitorUserEventGridInfoTable onRowClick={setNewSelectedRow} refreshData={refreshData} handleRefreshData={handleRefreshData} refresh={refresh} />
                </CustomTabPanel>
            </div>

            <DeleteVisitorUserDialog
                open={openDeleteVisitorUser}
                onClose={() => setOpenDeleteVisitorUser(false)}
                onRefresh={() => {
                    setData(null);
                    setSelectedRow(null);
                    handleRefreshData?.();
                }}
                id={selectedRow?.id}
            />

            {hasData && openEditVisitorUser && (
                <EditVisitorUserDialog
                    dataInfo={data}
                    onClose={() => setOpenEditVisitorUser(false)}
                    refreshData={refreshData}
                    handleRefreshData={handleRefreshData}
                    refresh={refresh}
                />
            )}

            <Popper
                open={openStatus}
                anchorEl={anchorRefStatus.current}
                placement="bottom-end"
                transition
                disablePortal
            >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                        <Paper sx={{ borderRadius: 1, p: 0, mt: 1 }}>
                            <ClickAwayListener onClickAway={handleCloseStatus}>
                                <CustomAdvancedMenuList>
                                    <MenuItem
                                        className="gap-3 items-center h-9  !text-red-500"
                                        onClick={() => {
                                            handleCloseStatus();
                                            setOpenDeleteVisitorUser(true);
                                        }}
                                    >
                                        <RemoveUserIcon />
                                        {t("button.remove")}
                                    </MenuItem>

                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default VisitorUserInfo